import React from 'react';
import { CheckCircle } from 'lucide-react';
export function About() {
  const benefits = ['Expert team of developers and designers', 'Agile development methodology', 'Transparent communication', 'On-time delivery guarantee', 'Post-launch support and maintenance', 'Competitive pricing models'];
  return <section id="about" className="py-20 bg-slate-900" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-21">
          <div className="relative" data-id="element-22">
            <div className="absolute inset-0 bg-red-600 rounded-2xl transform rotate-3 opacity-20" data-id="element-23"></div>
            <div className="relative bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-24">
              <div className="aspect-video bg-slate-900 rounded-xl overflow-hidden mb-6 flex items-center justify-center" data-id="element-25">
                <div className="text-center" data-id="element-26">
                  <div className="text-5xl font-bold text-white mb-2" data-id="element-27">5+</div>
                  <div className="text-red-500 font-medium" data-id="element-28">
                    Years of Excellence
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-29">
                <div className="bg-slate-900 p-4 rounded-lg text-center" data-id="element-30">
                  <div className="text-3xl font-bold text-white mb-1" data-id="element-31">100+</div>
                  <div className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-32">
                    Projects
                  </div>
                </div>
                <div className="bg-slate-900 p-4 rounded-lg text-center" data-id="element-33">
                  <div className="text-3xl font-bold text-white mb-1" data-id="element-34">50+</div>
                  <div className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-35">
                    Clients
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div data-id="element-36">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-37">
              Why Choose <span className="text-red-500" data-id="element-38">Hardy Blend</span>?
            </h2>
            <p className="text-slate-400 text-lg mb-8 leading-relaxed" data-id="element-39">
              We don't just write code; we build digital solutions that drive
              business growth. Our team combines technical expertise with
              creative innovation to deliver products that stand out in the
              market.
            </p>

            <div className="grid sm:grid-cols-2 gap-4" data-id="element-40">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-41">
                  <CheckCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-42" />
                  <span className="text-slate-300" data-id="element-43">{benefit}</span>
                </div>)}
            </div>

            <div className="mt-10" data-id="element-44">
              <a href="#contact-form" className="inline-block px-8 py-3 border border-red-500 text-red-500 font-bold rounded-lg hover:bg-red-600 hover:text-white transition-all" data-id="element-45">
                Learn More About Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}